import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Store/store";
import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import { StyleUtilities } from "./Components/Utilities";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// const globalStyles = StyleUtilities();
// globalStyles();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
